/* tslint:disable:no-empty */
function noop() { }
exports.noop = noop;
//# sourceMappingURL=noop.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/rxjs/util/noop.js
 ** module id = 44
 ** module chunks = 1
 **/